import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface LitigationsClaimsRommsProps {
  onBack: () => void;
}

export default function LitigationsClaimsRomms({ onBack }: LitigationsClaimsRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Litigations & Claims" />;
}
